import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            theme="light"
            className="toaster group"
            toastOptions={{
                classNames: {
                    toast:
                        "group toast group-[.toaster]:bg-surface group-[.toaster]:text-label group-[.toaster]:rounded-lg group-[.toaster]:border-0 group-[.toaster]:shadow-overlay",
                    description: "group-[.toast]:text-label-secondary",
                    actionButton:
                        "group-[.toast]:bg-green-tint group-[.toast]:text-green group-[.toast]:font-semibold",
                    cancelButton:
                        "group-[.toast]:bg-fill group-[.toast]:text-label-secondary",
                },
            }}
            {...props}
        />
    )
}

export { Toaster }
